/* import __COLOCATED_TEMPLATE__ from './appointment.hbs'; */
import { classNames } from '@ember-decorators/component';
import Component from '@ember/component';
import classic from 'ember-classic-decorator';
import styles from './appointment.module.scss';

@classic
@classNames(styles.component)
export default class ClientAttendanceAppointment extends Component {
  hasAddToCalendarModal = false;
}
